module.exports = __webpack_public_path__ + "static/6-deef2240a6927cf7310acefde309d354.png";